<template>
  <div class="showloadingbox">
    <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
            <circle 
                class="path" 
                cx="50" 
                cy="50" 
                r="20" 
                fill="none"  
                stroke-miterlimit="10"/>
        </svg>
    </div>
  </div>
</template>
<script>
export default {
    name: 'Loading'
}   
</script>

<style>

.el-dialog .loader{
    width: 32px;
}
.showloadingbox {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    position : absolute;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 999;
}
.showloadingbox .loader{
    position: relative;
    margin: 0 auto;
    width: 50px;
}
.showloadingbox .loader::before{
    content: '';
    display: block;
    padding-top: 100%;
}
.showloadingbox .loader .small{
    width: 32px;
}
.showloadingbox .circular{
    animation: rotate 2s linear infinite;
    height: 100%;
    transform-origin: center center;
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}
.showloadingbox .path{
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: dash 1.5s ease-in-out infinite;
    stroke-linecap: round;
    stroke: #2e68f8;
    stroke-width: 4px;
}
@keyframes rotate {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes dash {
    0% {
        stroke-dasharray: 1, 200;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -35px;
    }
    100% {
        stroke-dasharray: 89, 200;
        stroke-dashoffset: -124px;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/Loading.vue